type Props = {
  size: number;
  color?: string;
};

const Disabled = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3265 2.17725e-05C18.3027 -0.00248643 19.2701 0.211741 20.1716 0.629789C21.041 1.03135 21.8334 1.61567 22.5053 2.3509C23.1767 3.08393 23.7133 3.95617 24.0857 4.91856C24.4718 5.9202 24.6694 6.98393 24.6666 8.0786C24.6666 9.11117 24.4774 10.1871 24.1024 11.2816C23.7913 12.1963 23.3389 13.1454 22.764 14.1034C21.8528 15.6198 20.5998 17.202 19.0441 18.8052C16.4633 21.4628 13.9125 23.2958 13.8042 23.3733L13.1454 23.8443C12.8537 24.0518 12.4786 24.052 12.187 23.8443L11.5291 23.3733C11.4207 23.2989 8.86718 21.4628 6.28911 18.8052C4.73344 17.202 3.48043 15.6198 2.56925 14.1034C1.99431 13.1454 1.54467 12.1963 1.2308 11.2816C0.8558 10.187 0.666651 9.11118 0.666626 8.0786C0.666626 6.98397 0.86393 5.92017 1.25005 4.91856C1.62137 3.95561 2.15823 3.08308 2.83041 2.3509C3.50541 1.61292 4.2919 1.03292 5.16411 0.629789C6.06699 0.211142 7.02303 2.17725e-05 8.00925 2.17725e-05C9.3788 4.76915e-05 10.7152 0.418349 11.8764 1.2091C12.1542 1.39827 12.4183 1.60688 12.6683 1.83326C12.9183 1.60688 13.1823 1.39827 13.4601 1.2091C14.6212 0.418588 15.9572 9.57958e-05 17.3265 2.17725e-05ZM10.9523 5.30258V9.12977H7.52376V12.957H10.9523V16.7841H14.3809V12.957H17.8095V9.12977H14.3809V5.30258H10.9523Z"
        fill={color || '#212222'}
      />
    </svg>
  );
};

export default Disabled;
